import React from 'react';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewCheckboxBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewCheckboxBody className={`StyledPrintViewCheckboxBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewCheckboxBodyData" id={body.id}>
				{body.optionsAndResponses.map((check) => {
					return (
						<section className="section-checkbox-wrapper" key={`chk-option-${check.bodyOptionId}`}>
							<input
								id={check.bodyOptionId}
								className="section-checkbox"
								type="checkbox"
								title={check.bodyOptionText}
								checked={check.bodySelectedOptionId === 1}
							/>
							<span className="section-checkbox-label">{check.bodyOptionText}</span>
						</section>
					);
				})}
			</section>
		</StyledPrintViewCheckboxBody>
	);
}

export default PrintViewCheckboxBody;

const StyledPrintViewCheckboxBody = styled.section`
	display: block;
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
		&.PrintViewCheckboxBodyData {
			margin: var(--px-10) 0 var(--px-10) var(--px-30);
		}
	}
	.section-checkbox-wrapper {
		display: flex;
		align-items: flex-start;
		.section-checkbox {
			display: block;
			margin-top: var(--px-2);
		}
		.section-checkbox-label {
			margin-left: var(--px-5);
			line-height: normal;
		}
	}
`;
